import { loyaltyClient } from '../common/loyaltyClient';
import type {
  GetCustomerBalanceRequest,
  GetCustomerBalanceResponse,
  GetTransactionHistoryRequest,
  GetTransactionHistoryResponse,
  GetLoyaltyPolicyRequest,
  GetLoyaltyPolicyResponse,
  GetProductCreditPreviewRequest,
  GetProductCreditPreviewResponse,
} from './utils/types';

class LoyaltyAPIClient {
  public async getCustomerBalance({
    customerId,
    currency,
  }: GetCustomerBalanceRequest): Promise<GetCustomerBalanceResponse> {
    return await loyaltyClient
      .get(`/loyalty/customers/${customerId}/balance`, { params: { currency } })
      .then((res) => res.data);
  }

  public async getTransactionHistory({
    customerId,
    limit,
    lastEvaluatedKey,
    currency,
    category,
  }: GetTransactionHistoryRequest): Promise<GetTransactionHistoryResponse> {
    return await loyaltyClient
      .get(`/loyalty/customers/${customerId}/transactions`, {
        params: { limit, lastEvaluatedKey, currency, category },
      })
      .then((res) => res.data);
  }

  public async getLoyaltyPolicy({ currency }: GetLoyaltyPolicyRequest): Promise<GetLoyaltyPolicyResponse> {
    return await loyaltyClient.get('/loyalty/policy', { params: { currency } }).then((res) => res.data);
  }

  public async getProductCreditPreview({
    productId,
    currency,
  }: GetProductCreditPreviewRequest): Promise<GetProductCreditPreviewResponse> {
    return await loyaltyClient
      .get(`/loyalty/products/${productId}/creditAmount`, { params: { currency } })
      .then((res) => res.data);
  }
}

export const loyaltyAPIClient = new LoyaltyAPIClient();
